var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssociateDisabledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3        C1.6 3 0.5 4.4 0.5 6.1        C0.5 7.8 1.6 9.2 3 9.2        H11        C12.4 9.2 13.5 7.8 13.5 6.1        C13.5 4.4 12.4 3 11 3        H3        Z        M3 4.2        H11        C11.8 4.2 12.5 5 12.5 6.1        C12.5 7.2 11.8 8 11 8        H3        C2.2 8 1.5 7.2 1.5 6.1        C1.5 5 2.2 4.2 3 4.2        Z",
    fill: "#948B9E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.2,
    y: 4.7,
    width: 1.6,
    height: 2.8,
    fill: "#948B9E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 5.6,
    width: 3.4,
    height: 1.6,
    fill: "#948B9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociateDisabledIcon);
export default __webpack_public_path__ + "static/media/associate-disabled-icon.af203c3705a53688338ef35280083d70.svg";
export { ForwardRef as ReactComponent };